import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import api from "../api/client";
import { useAuth } from "../context/AuthContext";

const MasterLayout = ({ children }) => {
  const { user, logout } = useAuth();
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await api.get("/incidents/recent");
        const lastRead = localStorage.getItem('notification_last_read_time');
        const allNotifications = response.data;

        const unread = lastRead
          ? allNotifications.filter(n => new Date(n.createdAt) > new Date(lastRead))
          : allNotifications;

        setNotifications(unread);
      } catch (error) {
        console.error("Failed to fetch notifications", error);
      }
    };
    fetchNotifications();

    // Optional: Poll every 30 seconds
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const markAllAsRead = () => {
    localStorage.setItem('notification_last_read_time', new Date().toISOString());
    setNotifications([]);
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type='button'
          className='sidebar-close-btn'
        >
          <Icon icon='radix-icons:cross-2' />
        </button>
        <div>
          <Link to='/' className='sidebar-logo'>
            <img
              src='assets/a.png'
              alt='site logo'
              className='light-logo'
            />
            <img
              src='assets/l.png'
              alt='site logo'
              className='dark-logo'
            />
            <img
              src='assets/IMG.png'
              alt='site logo'
              className='logo-icon'
            />
          </Link>
        </div>
        <div className='sidebar-menu-area'>
          <ul className='sidebar-menu' id='sidebar-menu'>
            <li>
              <NavLink
                to='/'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='solar:home-smile-angle-outline'
                  className='menu-icon'
                />
                <span>Dashboard</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to='/incidents'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='solar:users-group-two-rounded-linear'
                  className='menu-icon'
                />
                <span>Student Fraud</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to='/exam-registrations'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='solar:clipboard-list-linear'
                  className='menu-icon'
                />
                <span>Exam Registration</span>
              </NavLink>
            </li>


            <li>
              <NavLink
                to='/faculties'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='solar:square-academic-cap-linear'
                  className='menu-icon'
                />
                <span>Faculty</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to='/departments'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='solar:buildings-2-linear'
                  className='menu-icon'
                />
                <span>Department</span>
              </NavLink>
            </li>

            <li>
              <NavLink
                to='/classes'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='solar:buildings-3-linear'
                  className='menu-icon'
                />
                <span>Class</span>
              </NavLink>
            </li>


            <li>
              <NavLink
                to='/reports'
                className={(navData) =>
                  navData.isActive ? "active-page" : ""
                }
              >
                <Icon
                  icon='heroicons:chart-bar'
                  className='menu-icon'
                />
                <span>Reports</span>
              </NavLink>
            </li>

            {user?.role === 'ADMIN' && (
              <li>
                <NavLink
                  to='/users-list'
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon='solar:users-group-rounded-linear'
                    className='menu-icon'
                  />
                  <span>Users</span>
                </NavLink>
              </li>
            )}

            <li>
              <NavLink to='/sign-in' onClick={logout}>
                <Icon
                  icon='lucide:power'
                  className='menu-icon text-danger-600'
                />
                <span>Logout</span>
              </NavLink>
            </li>

          </ul>
        </div >
      </aside >

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className='navbar-header'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-4'>
                <button
                  type='button'
                  className='sidebar-toggle'
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon='iconoir:arrow-right'
                      className='icon text-2xl non-active'
                    />
                  ) : (
                    <Icon
                      icon='heroicons:bars-3-solid'
                      className='icon text-2xl non-active '
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type='button'
                  className='sidebar-mobile-toggle'
                >
                  <Icon icon='heroicons:bars-3-solid' className='icon' />
                </button>
                <form className='navbar-search'>
                  <input type='text' name='search' placeholder='Search' />
                  <Icon icon='ion:search-outline' className='icon' />
                </form>
              </div>
            </div>
            <div className='col-auto'>
              <div className='d-flex flex-wrap align-items-center gap-3'>
                {/* ThemeToggleButton */}
                <ThemeToggleButton />

                <div className='dropdown'>
                  <button
                    className='has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <Icon
                      icon='iconoir:bell'
                      className='text-primary-light text-xl'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-lg p-0'>
                    <div className='m-16 py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-0'>
                          Notifications
                        </h6>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {notifications.length > 0 && (
                          <button onClick={markAllAsRead} className="text-sm text-primary-600 hover-text-primary-800 fw-medium">
                            Mark as Read
                          </button>
                        )}
                        <span className='text-primary-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center'>
                          {notifications.length}
                        </span>
                      </div>
                    </div>
                    <div className='max-h-400-px overflow-y-auto scroll-sm pe-4'>
                      {notifications.length > 0 ? (
                        notifications.map((notification) => (
                          <Link
                            key={notification.id}
                            to='/incidents'
                            className='px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50'
                          >
                            <div className='text-black hover-bg-transparent hover-text-primary d-flex align-items-center gap-3'>
                              <span className='w-44-px h-44-px bg-warning-subtle text-warning-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0'>
                                <Icon
                                  icon='solar:shield-warning-outline'
                                  className='icon text-xxl'
                                />
                              </span>
                              <div>
                                <h6 className='text-md fw-semibold mb-4'>
                                  New Fraud Reported
                                </h6>
                                <p className='mb-0 text-sm text-secondary-light text-w-200-px'>
                                  {notification.fullName} ({notification.studentId}) - {notification.subject}
                                </p>
                              </div>
                            </div>
                            <span className='text-sm text-secondary-light flex-shrink-0'>
                              {new Date(notification.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </span>
                          </Link>
                        ))
                      ) : (
                        <div className="text-center py-3 text-secondary-light">
                          No recent notifications
                        </div>
                      )}
                    </div>
                    <div className='text-center py-12 px-16'>
                      <Link
                        to='/incidents'
                        className='text-primary-600 fw-semibold text-md'
                      >
                        See All Incidents
                      </Link>
                    </div>
                  </div>
                </div>
                {/* Notification dropdown end */}
                <div className='dropdown'>
                  <button
                    className='d-flex justify-content-center align-items-center rounded-circle'
                    type='button'
                    data-bs-toggle='dropdown'
                  >
                    <img
                      src='assets/IMG.png'
                      alt='image_user'
                      className='w-40-px h-40-px object-fit-cover rounded-circle'
                    />
                  </button>
                  <div className='dropdown-menu to-top dropdown-menu-sm'>
                    <div className='py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2'>
                      <div>
                        <h6 className='text-lg text-primary-light fw-semibold mb-2'>
                          {user?.fullName || 'User'}
                        </h6>
                        <span className='text-secondary-light fw-medium text-sm'>
                          {user?.role || 'Guest'}
                        </span>
                      </div>
                      <button type='button' className='hover-text-danger'>
                        <Icon
                          icon='radix-icons:cross-1'
                          className='icon text-xl'
                        />
                      </button>
                    </div>
                    <ul className='to-top-list'>

                      <li>
                        <NavLink
                          className='dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3'
                          to='/sign-in'
                          onClick={logout}
                        >
                          <Icon icon='lucide:power' className='icon text-xl text-danger-600' />{" "}
                          Log Out
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className='dashboard-main-body'>{children}</div>

        {/* Footer section */}
        <footer className='d-footer'>
          <div className='row align-items-center justify-content-between'>
            <div className='col-auto'>
              <p className='mb-0'>© {new Date().getFullYear()} Kismayo University. All Rights Reserved.</p>
            </div>
            <div className='col-auto'>
              <div className='d-flex align-items-center gap-3'>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon-circle">
                  <Icon icon="ic:baseline-facebook" className="text-xl" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon-circle">
                  <Icon icon="ri:instagram-line" className="text-xl" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon-circle">
                  <Icon icon="ri:twitter-x-fill" className="text-xl" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon-circle">
                  <Icon icon="ri:linkedin-fill" className="text-xl" />
                </a>
              </div>
            </div>
          </div>
        </footer>
      </main>
    </section >
  );
};

export default MasterLayout;
